export const DISPLAY_TYPES = {
  SITE: 'site',
  SITE_2: 'site2',
  SITE_PORTRAIT: 'site-portrait',
  SHOWINGS_POSTER: 'showings-poster',
  SHOWINGS_BANNER: 'showings-banner',
  SHOWINGS_LIST: 'showings-list',
  SCREEN: 'screen',
  MEDIA: 'media',
  SCREEN_LANDSCAPE: 'screen-landscape',
  SCREEN_LANDSCAPE_POSTER_LEFT: 'screen-landscape-poster-left',
  SCREEN_PORTRAIT: 'screen-portrait',
  SCREEN_PORTRAIT_STATUS_STREAM: 'screen-portrait-status-stream',
  CUSTOM: 'custom'
}

DISPLAY_TYPES.ALL = _.values(DISPLAY_TYPES)

export function urlToProperties (displayUrl) {
  const arguements = displayUrl.split('?')
  const routeParameters = arguements[0].split('/')
  const screenId = routeParameters[routeParameters.length - 1]

  if (arguements.length < 2) return null
  else {
    const args = _.map(arguements[1].split('&'), arg => {
      const keyValue = arg.split('=')
      const key = keyValue[0]
      let value = keyValue[1]
      if (value === 'true') {
        value = true
      } else if (value === 'false') {
        value = false
      } else {
        value = decodeURIComponent(value)
      }
      return { key: _.camelCase(key), value }
    })
    displayUrl.includes('screen') && args.push({ key: 'screenId', value: parseInt(screenId) })
    return args
  }
}

export function getDisplayType (displayUrl) {
  return _.find(displayUrl.split('/'), urlPart => DISPLAY_TYPES.ALL.includes(urlPart))
}

export const defaultUrlProperties = {
  displayMedia: true,
  displayTrailers: true,
  displayFooter: false,
  displayMessages: false,
  titleClassId: null,
  muted: false,
  mediaClassId: null,
  marginHorizontal: 16,
  marginVertical: 0,
  cover: false,
  mode: null,
  moviesPerPage: 6,
  interval: 5000,
  screenId: null,
  moreBefore: false,
  moreAfter: false,
  displayMovieBanners: false,
  displayMoviePosters: false,
  displayAnimatedPosters: false,
  displayShowingBadges: false,
  footerBackgroundColor: '#ffffff',
  mediaBackgroundColor: '#000000',
  messageBackgroundColor: '#AAAAAA',
  defaultDisplayDuration: 5,
  displayTime: false,
  footerTextColor: '#191c5e',
  showLogo: true,
  showAllAvailableShowtimes: false,
  showScreenName: true,
  showRatingReason: true,
  cleanImage: false,
  detail: false,
  showingsHidePoster: true,
  showMovieName: true,
  showShowingBadges: true,
  hasLink: false,
  displayButton: false,
  posterShowBorder: true,
  posterBorderRadius: 2,
  showMotionPoster: true,
  showingStatusFontSize: 4,
  highlightRRated: false,
  disableOfficialSymbol: false
}
